// import { rgbToHex } from 'helpers/colors';

export const enum IconSize {
  like = 18,
  dot = 16,
  handle = 28,
  smallhandle = 22,
  tiny = 16,
  small = 24,
  normal = 32,
  medium = 48,
  large = 64,
  avatar = 36,
  avatar_large = 96,
  avatar_medium = 64,
  avatar_small = 32,
  avatar_tiny = 24,
}

export enum IconSymbol {
  _none = '_none',
  // logos
  logo_w = 'CT-logo',
  logo_g = 'CT-logo',
  // block types, must be lowercase
  chat = 'chat',
  bulletin = 'bulletin',
  list = 'list',
  library = 'library',
  document = 'document',
  poll = 'poll',
  meeting = 'meeting',
  sudoku = 'sudoku',
  // list types, must be lowercase
  procon = 'procon',
  swot = 'swot',
  kanban = 'kanban',
  singlelist = 'list',
  multilist = 'multilist',
  // general icons
  alert = 'alert',
  arrow = 'arrow',
  audio = 'audio',
  audioOff = 'audioOff',
  bin = 'bin',
  canvas = 'canvas',
  check = 'check',
  checkNot = 'checkNot',
  close = 'close',
  cloudSaved = 'cloudSaved',
  cloudSaving = 'cloudSaving',
  copy = 'copy',
  down = 'down',
  download = 'download',
  dot = 'dot',
  dot_filled = 'dot_filled',
  ellipsis = 'ellipsis',
  email = 'email',
  email_accent = 'email_accent',
  emailOpen = 'emailOpen',
  emailSent = 'emailSent',
  emailDraft = 'emailDraft',
  exit = 'exit',
  expandTail = 'expandTail',
  folder = 'folder',
  folderOpen = 'folderOpen',
  folderAdd = 'folderAdd',
  fullScreen = 'fullScreen',
  fullScreenExit = 'fullScreenExit',
  hamburger = 'hamburger',
  hidden = 'hidden',
  info = 'info',
  key = 'key',
  layers = 'layers',
  leader = 'leader',
  left = 'left',
  link = 'link',
  listView = 'listView',
  tileView = 'tileView',
  loading = 'loading',
  lock = 'lock',
  unlock = 'unlock',
  longlist = 'longlist',
  minus = 'minus',
  newWindow = 'newWindow',
  shield = 'shield',
  pencil = 'pencil',
  picture = 'picture',
  pin = 'pin',
  pin_filled = 'pin_filled',
  pin2 = 'pin2',
  pin2_filled = 'pin2_filled',
  unpin = 'unpin',
  unpin_filled = 'unpin_filled',
  plus = 'plus',
  question = 'question',
  record = 'record',
  recording = 'recording',
  reload = 'reload',
  reply = 'reply',
  right = 'right',
  scroll = 'scroll',
  send = 'send',
  settings = 'settings',
  share = 'share',
  sort = 'sort',
  sortByTime = 'sortByTime',
  sortByName = 'sortByName',
  spinnerOnDark = 'spinnerOnDark',
  spinnerOnLight = 'spinnerOnLight',
  star = 'star',
  star_bg = 'star_bg',
  star_filled = 'star_filled',
  table = 'table',
  thumb = 'thumb',
  thumb_filled = 'thumb_filled',
  up = 'up',
  upload = 'upload',
  user = 'user',
  userUnsubscribed = 'userUnsubscribed',
  video = 'video',
  videoOff = 'videoOff',
  visible = 'visible',
  zoomReset = 'zoomReset',
  // mime types
  mime_general = 'mime_general',
  mime_img = 'mime_img',
  mime_video = 'mime_video',
  mime_pdf = 'mime_pdf',
  mime_docx = 'mime_docx',
  mime_xlsx = 'mime_xlsx',
  mime_pptx = 'mime_pptx',
  mime_unknown = 'mime_unknown',
  // list icons
  newItem = 'newItem',
  cycle = 'cycle',
  smiling = 'smiling',
  sad = 'sad',
  shieldCheck = 'shieldCheck',
  shieldPlus = 'shieldPlus',
  shieldMinus = 'shieldMinus',
  trendUp = 'trendUp',
  trendDown = 'trendDown',
  // drag handles
  drag2x4 = 'drag2x4',
  drag4x2 = 'drag4x2',
  drag3x5 = 'drag3x5',
  drag5x3 = 'drag5x3',
  // canvas icons
  note = 'note',
  parking = 'parking',
  tree = 'tree',
  trafficLight = 'trafficLight',
  car = 'car',
}
export enum IconVariant {
  normal = 'normal',
  dark = 'dark',
  light = 'light',
  white = 'white',
  accent = 'accent',
}

function rgbToHex(r: number, g: number, b: number): string {
  const clamp = (val: number) => Math.max(0, Math.min(255, val));
  const toHex = (val: number) => clamp(val).toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export const IconVariantColor: Record<IconVariant, string> = {
  [IconVariant.normal]: rgbToHex(128, 128, 128),
  [IconVariant.dark]: rgbToHex(60, 60, 60),
  [IconVariant.light]: rgbToHex(192, 192, 192),
  [IconVariant.white]: rgbToHex(255, 255, 255),
  [IconVariant.accent]: rgbToHex(255, 150, 30),
};

// Anchor point per icon: the point in the icon relative to top left,
// that gets positioned at its insertion point.
// Format: [x, y, viewBox?]
// where x an y indicate where the icon's 'anchor' point is,
// and viewBox is the size of the viewBox, assumed square, used for scaling.
export const IconAnchors: Partial<
  Record<IconSymbol, [number, number, number?]>
> = {
  [IconSymbol.note]: [15.4, 22.75, 24],
  [IconSymbol.parking]: [12, 24, 24],
  [IconSymbol.tree]: [12, 24, 24],
  [IconSymbol.trafficLight]: [12, 24, 24],
  [IconSymbol.car]: [12, 24, 24],
};
